import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

let ioBroken = false;
const ioListeners = new Set();
function subscribeIo(l) {
  ioListeners.add(l);
  return () => ioListeners.delete(l);
}
function markIoBroken() {
  if (ioBroken) return;
  ioBroken = true;
  ioListeners.forEach((l) => l());
}

export function IoSentinel() {
  const ref = useRef(null);
  const inView = useInView(ref);
  useEffect(() => {
    const t = setTimeout(() => {
      const el = ref.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const visible = r.top < window.innerHeight && r.bottom > 0;
      if (visible && !inView) markIoBroken();
    }, 2000);
    return () => clearTimeout(t);
  }, [inView]);
  return <div ref={ref} aria-hidden="true" style={{ position: "absolute", top: 0, left: 0, width: 1, height: 1, pointerEvents: "none" }} />;
}

export function useSafeInView() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [forced, setForced] = useState(ioBroken);
  useEffect(() => subscribeIo(() => setForced(true)), []);
  return [ref, inView || forced];
}

export function Reveal({ children, delay = 0, className = "", ...rest }) {
  const [ref, show] = useSafeInView();
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 28 }}
      animate={show ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.9, ease: EASE, delay }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0.35 }) {
  return (
    <h1 className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * 0.13 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </h1>
  );
}

export { EASE };
